export default "__VITE_ASSET__Bd5hEVen__"